/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { OutputImageDynamicPart } from "./OutputImageDynamicPart";
import type { OutputImageStaticPart } from "./OutputImageStaticPart";
import type { OutputTextPart } from "./OutputTextPart";

export type OutputContentList = (
  | OutputTextPart
  | OutputImageDynamicPart
  | OutputImageStaticPart
)[];
